/**
 * Hardcoded category-to-book-IDs mapping (up to 40 books per category)
 * 
 * HOW TO GENERATE:
 * 1. Open Debug screen in the app
 * 2. Tap "📚 Generate Category Book IDs" button
 * 3. Copy the TypeScript code from console logs
 * 4. Replace the export below with the copied code
 * 
 * CATEGORIES WITH 6+ BOOKS (displayed in the app):
 * - psychology (40), parenting (40), health (40), leadership (40), business (40)
 * - science (38), philosophy (40), productivity (40), spirituality (40), management (40)
 * - entrepreneurship (40), finance (40), lifestyle (33), mentalhealth (23), relationships (22)
 * - communication (21), marketing (16), money (22), creativity (11), biographymemoir (10)
 * - personalfinance (10), writing (10), wealth (8), inspirational (7), investment (6)
 * 
 * CATEGORIES WITH <6 BOOKS (NOT displayed):
 * - socialmedia (4), art (4), teaching (3), mindfulness (3)
 * - minimalism (1), motivational (1), social (1), fitness (1), love (1)
 * 
 * Note: Categories like "mindfulness" have few books because of exact category matching.
 * Books may use similar tags (e.g., "meditation", "self-awareness") that don't match.
 */

export const CATEGORY_BOOK_IDS: { [category: string]: string[] } = {
  // Placeholder - run the debug tool to generate real data
  "psychology": [
    "100",
    "103",
    "106",
    "107",
    "108",
    "109",
    "10",
    "110",
    "112",
    "114",
    "115",
    "116",
    "117",
    "119",
    "11",
    "120",
    "122",
    "125",
    "126",
    "127",
    "128",
    "129",
    "12",
    "130",
    "131",
    "133",
    "135",
    "136",
    "137",
    "138",
    "13",
    "140",
    "141",
    "144",
    "145",
    "146",
    "147",
    "149",
    "14",
    "150"
  ],
  "parenting": [
    "102",
    "103",
    "104",
    "106",
    "107",
    "108",
    "110",
    "111",
    "112",
    "113",
    "114",
    "116",
    "117",
    "119",
    "120",
    "122",
    "123",
    "124",
    "125",
    "126",
    "128",
    "129",
    "130",
    "131",
    "132",
    "133",
    "134",
    "135",
    "136",
    "137",
    "138",
    "139",
    "140",
    "141",
    "142",
    "143",
    "144",
    "145",
    "146",
    "147"
  ],
  "health": [
    "102",
    "110",
    "111",
    "112",
    "117",
    "123",
    "125",
    "127",
    "133",
    "135",
    "137",
    "140",
    "143",
    "146",
    "147",
    "148",
    "149",
    "150",
    "2",
    "366",
    "37",
    "381",
    "385",
    "38",
    "403",
    "409",
    "449",
    "455",
    "466",
    "472",
    "473",
    "475",
    "487",
    "498",
    "501",
    "526",
    "530",
    "532",
    "533",
    "53"
  ],
  "science": [
    "102",
    "104",
    "10",
    "110",
    "115",
    "116",
    "125",
    "135",
    "136",
    "137",
    "140",
    "143",
    "147",
    "148",
    "163",
    "182",
    "188",
    "190",
    "211",
    "224",
    "230",
    "258",
    "260",
    "262",
    "266",
    "271",
    "276",
    "285",
    "286",
    "288",
    "299",
    "2",
    "357",
    "362",
    "377",
    "381",
    "384",
    "389",
    "38",
    "390"
  ],
  "leadership": [
    "103",
    "10",
    "128",
    "12",
    "151",
    "152",
    "153",
    "154",
    "155",
    "156",
    "158",
    "159",
    "161",
    "162",
    "163",
    "165",
    "166",
    "169",
    "171",
    "174",
    "178",
    "179",
    "17",
    "181",
    "184",
    "186",
    "188",
    "189",
    "18",
    "192",
    "193",
    "195",
    "196",
    "197",
    "198",
    "199",
    "19",
    "200",
    "201",
    "202"
  ],
  "business": [
    "103",
    "106",
    "10",
    "110",
    "115",
    "128",
    "12",
    "151",
    "152",
    "153",
    "154",
    "155",
    "156",
    "157",
    "158",
    "159",
    "160",
    "161",
    "162",
    "163",
    "164",
    "165",
    "166",
    "167",
    "168",
    "169",
    "16",
    "170",
    "171",
    "172",
    "173",
    "174",
    "175",
    "176",
    "177",
    "178",
    "179",
    "17",
    "180",
    "181"
  ],
  "philosophy": [
    "103",
    "11",
    "128",
    "13",
    "15",
    "190",
    "249",
    "252",
    "260",
    "263",
    "267",
    "305",
    "309",
    "30",
    "310",
    "311",
    "323",
    "328",
    "330",
    "341",
    "356",
    "357",
    "358",
    "365",
    "368",
    "373",
    "37",
    "39",
    "3",
    "404",
    "405",
    "40",
    "411",
    "413",
    "419",
    "41",
    "432",
    "434",
    "440",
    "445"
  ],
  "productivity": [
    "10",
    "110",
    "151",
    "155",
    "156",
    "165",
    "166",
    "171",
    "183",
    "184",
    "18",
    "1",
    "210",
    "233",
    "236",
    "241",
    "24",
    "253",
    "255",
    "256",
    "259",
    "260",
    "261",
    "267",
    "275",
    "281",
    "284",
    "28",
    "291",
    "304",
    "307",
    "308",
    "30",
    "311",
    "312",
    "315",
    "317",
    "318",
    "319",
    "31"
  ],
  "spirituality": [
    "113",
    "11",
    "13",
    "252",
    "305",
    "309",
    "323",
    "334",
    "337",
    "341",
    "354",
    "356",
    "367",
    "392",
    "397",
    "39",
    "405",
    "40",
    "422",
    "432",
    "445",
    "45",
    "468",
    "486",
    "488",
    "489",
    "491",
    "493",
    "521",
    "527",
    "538",
    "568",
    "569",
    "585",
    "619",
    "627",
    "633",
    "649",
    "676",
    "686"
  ],
  "management": [
    "12",
    "151",
    "152",
    "153",
    "154",
    "155",
    "156",
    "157",
    "158",
    "159",
    "161",
    "162",
    "163",
    "165",
    "166",
    "169",
    "16",
    "171",
    "173",
    "174",
    "177",
    "178",
    "17",
    "181",
    "183",
    "184",
    "186",
    "189",
    "18",
    "191",
    "192",
    "193",
    "194",
    "195",
    "196",
    "197",
    "198",
    "199",
    "19",
    "200"
  ],
  "entrepreneurship": [
    "151",
    "152",
    "153",
    "154",
    "155",
    "156",
    "157",
    "158",
    "159",
    "160",
    "161",
    "162",
    "163",
    "164",
    "165",
    "166",
    "167",
    "168",
    "169",
    "16",
    "171",
    "173",
    "174",
    "175",
    "176",
    "177",
    "178",
    "179",
    "17",
    "180",
    "181",
    "182",
    "183",
    "184",
    "185",
    "186",
    "187",
    "188",
    "189",
    "18"
  ],
  "finance": [
    "151",
    "158",
    "164",
    "168",
    "172",
    "186",
    "187",
    "199",
    "202",
    "207",
    "212",
    "217",
    "21",
    "220",
    "225",
    "235",
    "237",
    "240",
    "243",
    "244",
    "245",
    "249",
    "255",
    "271",
    "278",
    "286",
    "287",
    "291",
    "296",
    "331",
    "34",
    "364",
    "36",
    "3",
    "483",
    "49",
    "522",
    "528",
    "547",
    "564"
  ],
  "lifestyle": [
    "2",
    "307",
    "308",
    "313",
    "315",
    "334",
    "338",
    "339",
    "354",
    "369",
    "376",
    "377",
    "385",
    "387",
    "389",
    "397",
    "403",
    "409",
    "419",
    "425",
    "429",
    "443",
    "468",
    "471",
    "474",
    "475",
    "498",
    "533",
    "574",
    "578",
    "588",
    "705",
    "744"
  ],
  "mentalhealth": [
    "306",
    "310",
    "337",
    "355",
    "367",
    "378",
    "386",
    "388",
    "392",
    "415",
    "428",
    "440",
    "452",
    "463",
    "504",
    "516",
    "534",
    "559",
    "582",
    "605",
    "607",
    "740",
    "742"
  ],
  "relationships": [
    "103",
    "109",
    "128",
    "131",
    "133",
    "137",
    "138",
    "139",
    "149",
    "14",
    "330",
    "418",
    "422",
    "431",
    "476",
    "503",
    "508",
    "515",
    "560",
    "605",
    "86",
    "96"
  ],
  "money": [
    "164",
    "168",
    "185",
    "202",
    "21",
    "225",
    "237",
    "240",
    "243",
    "296",
    "300",
    "36",
    "77",
    "78",
    "79",
    "80",
    "81",
    "88",
    "89",
    "8",
    "91",
    "97"
  ],
  "communication": [
    "329",
    "332",
    "343",
    "362",
    "384",
    "430",
    "431",
    "433",
    "435",
    "437",
    "467",
    "503",
    "513",
    "553",
    "610",
    "661",
    "664",
    "684",
    "688",
    "689",
    "708"
  ],
  "marketing": [
    "361",
    "399",
    "438",
    "454",
    "457",
    "464",
    "480",
    "517",
    "531",
    "548",
    "554",
    "581",
    "665",
    "680",
    "706",
    "743"
  ],
  "creativity": [
    "155",
    "193",
    "226",
    "230",
    "242",
    "249",
    "253",
    "267",
    "275",
    "284",
    "293"
  ],
  "biographymemoir": [
    "162",
    "242",
    "244",
    "35",
    "42",
    "56",
    "62",
    "64",
    "68",
    "94"
  ],
  "personalfinance": [
    "237",
    "243",
    "36",
    "77",
    "79",
    "80",
    "81",
    "89",
    "8",
    "91"
  ],
  "writing": [
    "336",
    "344",
    "346",
    "402",
    "404",
    "424",
    "499",
    "511",
    "513",
    "519"
  ],
  "wealth": [
    "164",
    "202",
    "237",
    "243",
    "79",
    "81",
    "91",
    "97"
  ],
  "inspirational": [
    "11",
    "128",
    "13",
    "177",
    "252",
    "72",
    "74"
  ],
  "investment": [
    "158",
    "225",
    "34",
    "36",
    "80",
    "81"
  ],
  "socialmedia": [
    "336",
    "484",
    "492",
    "500"
  ],
  "art": [
    "626",
    "627",
    "685",
    "696"
  ],
  "teaching": [
    "110",
    "119",
    "124"
  ],
  "mindfulness": [
    "40",
    "72",
    "75"
  ],
  "minimalism": [
    "134"
  ],
  "motivational": [
    "252"
  ],
  "social": [
    "288"
  ],
  "fitness": [
    "2"
  ],
  "love": [
    "674"
  ]
};

